import { render, staticRenderFns } from "./SpaceResearchBarPanel.vue?vue&type=template&id=7b3dcac8&scoped=true"
import script from "./SpaceResearchBarPanel.vue?vue&type=script&lang=js"
export * from "./SpaceResearchBarPanel.vue?vue&type=script&lang=js"
import style0 from "./SpaceResearchBarPanel.vue?vue&type=style&index=0&id=7b3dcac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3dcac8",
  null
  
)

export default component.exports